import React from 'react'
import ReactDOM from 'react-dom'
import Provider from '@react/react-spectrum/Provider'
import './style/index.css'
import * as serviceWorker from './serviceWorker'

import App from './component/App'

export const getTheme = () => {
    const curUrl = new URL(document.location.href)
    const parent = curUrl.searchParams.get('parent')
    if (parent === 'cloudcity') {
        const colorMode = curUrl.searchParams.get('colorMode')
        if (colorMode === 'dark') {
            return 'dark'
        }
    }
    return 'light'
}

export const getScale = () => {
    const curUrl = new URL(document.location.href)
    const parent = curUrl.searchParams.get('parent')
    if (parent === 'cloudcity') {
        const scale = curUrl.searchParams.get('themeScale')
        if (scale === 'large') {
            return 'large'
        }
    }
    return 'medium'
}

ReactDOM.render(
    <Provider theme={getTheme()} scale={getScale()} typekitId="wvs4frr" className="adobe-skycity-provider" data-theme={getTheme()}>
        <App />
    </Provider>, document.getElementById('root'))

serviceWorker.unregister()
